import React from 'react';
import { FaWhatsapp, FaInstagram, FaFacebook, FaTiktok, FaHeart } from 'react-icons/fa';
import { SOCIAL_LINKS, WHATSAPP_GENERAL_LINK } from '../data/products';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white relative overflow-hidden">
            <div className="h-1 bg-gradient-to-r from-dulce-pink-400 via-dulce-rose-400 to-dulce-pink-500" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-3 mb-4">
                            <span className="text-4xl">🧁</span>
                            <div>
                                <h3 className="font-great-vibes text-3xl text-dulce-pink-400">Dulce Mora</h3>
                                <p className="text-gray-400 text-xs tracking-widest uppercase">Repostería Artesanal</p>
                            </div>
                        </div>
                        <p className="text-gray-400 text-sm leading-relaxed max-w-md mb-6">
                            Hecho con amor, para endulzar tus mejores momentos. Repostería artesanal con
                            ingredientes naturales y de la mejor calidad. 💕
                        </p>
                        <div className="flex gap-3">
                            <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-gradient-to-br hover:from-purple-500 hover:via-pink-500 hover:to-orange-400 p-2.5 rounded-xl transition-all hover:scale-110">
                                <FaInstagram size={20} />
                            </a>
                            <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-blue-600 p-2.5 rounded-xl transition-all hover:scale-110">
                                <FaFacebook size={20} />
                            </a>
                            <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-gray-700 p-2.5 rounded-xl transition-all hover:scale-110">
                                <FaTiktok size={20} />
                            </a>
                            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                                className="bg-white/10 hover:bg-green-500 p-2.5 rounded-xl transition-all hover:scale-110">
                                <FaWhatsapp size={20} />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="font-semibold text-lg mb-4 text-dulce-pink-400">Navegación</h4>
                        <ul className="space-y-2">
                            {[
                                { name: 'Inicio', href: '#inicio' },
                                { name: 'Productos', href: '#productos' },
                                { name: 'Promociones', href: '#promociones', highlight: true },
                                { name: 'Nosotros', href: '#nosotros' },
                                { name: 'Precios', href: '#precios' },
                                { name: 'Contacto', href: '#contacto' },
                            ].map((link) => (
                                <li key={link.name}>
                                    <a href={link.href} className="text-gray-400 hover:text-dulce-pink-400 text-sm transition-colors flex items-center gap-2">
                                        <span className="text-dulce-pink-500 text-xs">♥</span>
                                        {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold text-lg mb-4 text-dulce-pink-400">Contacto</h4>
                        <div className="space-y-3">
                            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                                className="flex items-center gap-3 text-gray-400 hover:text-green-400 transition-colors text-sm">
                                <FaWhatsapp size={18} className="text-green-500" />
                                +569 93396909
                            </a>
                            <p className="text-gray-400 text-sm flex items-center gap-3">
                                <span>🕐</span>Pedidos con 24 hrs
                            </p>
                            <p className="text-gray-400 text-sm flex items-center gap-3">
                                <span>📍</span>Chile
                            </p>
                        </div>
                        <div className="mt-6">
                            <a href={WHATSAPP_GENERAL_LINK} target="_blank" rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white py-2.5 px-5 rounded-full text-sm font-semibold shadow-lg transition-all hover:scale-105">
                                <FaWhatsapp size={16} />
                                Haz tu Pedido
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-between gap-4">
                    <p className="text-gray-500 text-sm text-center md:text-left">
                        © {currentYear} Repostería Dulce Mora. Todos los derechos reservados.
                        <a
                            href="https://nimex-software.netlify.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group block mt-2 font-extrabold italic text-base tracking-wide text-[#F04B3E] hover:text-[#D93A2F] transition-all duration-300 cursor-pointer"
                        >
                            <span className="group-hover:drop-shadow-[0_0_6px_rgba(240,75,62,0.5)]">
                                ✦ Nimex somos todos ✦
                            </span>
                        </a>
                    </p>
                    <p className="text-gray-500 text-sm flex items-center gap-1">
                        Hecho con <FaHeart className="text-dulce-pink-500 animate-heart-beat" size={12} /> en Chile
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;